<template>
  <div>
    <div class="login">
      <p>恋爱物语登录</p>
      <template v-if="getLoginState() === GLOBAL.LOGIN_STATE_PART0 ">
        <div>
          <input class="login-input"
                 v-model="account"
                 type="text"
                 placeholder="请输入手机号码"
                 onkeyup="this.value=this.value.replace(/[^0-9\-]/g,'')"
                 @focusin="inputFocusin"
                 @focusout="inputFocusout">
          <p class="msg-tips"
             v-if="accountMsg">{{"*"+accountMsg}}</p>
          <input class="login-submit" type="button" value="下一步" @click="loginActionAccount">
          <p class="tag-tips">无账号？请前往手机端App设置！</p>
        </div>
      </template>
      <template v-else-if="getLoginState() === GLOBAL.LOGIN_STATE_PART2">
        <div>
          <input class="login-input"
                 v-model="pwd"
                 type="password"
                 placeholder="请输入密码"
                 @focusin="inputFocusin"
                 @focusout="inputFocusout">
          <p class="msg-tips"
             v-if="pwdMsg">{{"*" + pwdMsg}}</p>
          <input class="login-submit" type="button" value="完成" @click="loginActionPwd">
          <p class="tag-tips">忘记/未设置密码？请前往手机端App设置！</p>
          <p class="back"
             @click="loginPwdBack">&lt;&lt; 返回上一步</p>
        </div>
      </template>
    </div>
    <login-dialog v-if="getLoginState() === GLOBAL.LOGIN_STATE_PART1" />
    <div class="tips"
         :class="{on: tips!=''}">
      <p>{{ tips }}</p>
    </div>
  </div>
</template>

<script>
import LoginDialog from './login_dialog'
import { Params } from '@/util/util.js'
import Qs from 'qs'

export default {
  name: 'login',
  data () {
    return {
      account: '',
      pwd: '',
      accountMsg: "",
      pwdMsg: "",
      tips: ''
    }
  },
  methods: {
    inputFocusin: function (event) {
      var dom = event.target;
      var temp = dom.getAttribute("placeholder");
      dom.setAttribute("hint", temp);
      dom.setAttribute("placeholder", "");
    },
    inputFocusout: function (event) {
      var dom = event.target;
      var temp = dom.getAttribute("hint");
      dom.setAttribute("placeholder", temp);
      dom.setAttribute("hint", "");
    },
    loginActionAccount: function () {
      const that = this;
      that.accountMsg = '';
      if (!that.account || that.account.length < 11) {
        that.accountMsg = "请输入正确的手机号";
        return;
      }
      var params = new Params(that, {
        phone: that.account,
        method: 'login.phone.userlist.web'
      });
      this.$axios.post(that.$store.state.urlData.url, Qs.stringify(params), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (res) {
        console.log(res);
        if (res.data.errCode == 0) {
          if (res.data.data && res.data.data.length > 0) {
            that.$store.commit('setLoginAccountList', res.data.data);
            that.$store.commit('setLoginState', that.GLOBAL.LOGIN_STATE_PART1);
          } else {
            that.accountMsg = "此账户不存在哦~";
            return;
          }
        } else {
          that.accountMsg = res.data.errMsg;
        }
      });
    },
    showTips: function (tips, that) {
      that.tips = tips;
      setTimeout(() => {
        that.tips = "";
      }, 3000);
    },
    loginActionPwd: function () {
      const that = this;
      if (!that.pwd || that.pwd.length < 6) {
        that.pwdMsg = "请输入正确的密码";
        return;
      }
      var items = this.$store.state.loginAccountList;
      var pos = -1;
      for (var i = 0; i < items.length; i++) {
        if (items[i].choose) {
          pos = i;
          break;
        }
      }
      if (pos == -1) {
        that.showTips("请重新登录", this);
        that.$store.commit('setLoginState', this.GLOBAL.LOGIN_STATE_PART0);
        return;
      }
      var item = items[pos];
      var params = new Params(that, {
        phone: that.account,
        passwd: that.pwd,
        uid: item.uid,
        method: 'login.phone.special.web'
      });
      //that.$store.state.urlData.url
      this.$axios.post(that.$store.state.urlData.url, Qs.stringify(params), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (res) {
        console.log(res);
        if (res.data.errCode == 0) {
          that.$store.commit('setLoginAccount', res.data.user);
          that.$store.commit('setLoginAccountList', null);
          that.$store.commit('setLoginState', that.GLOBAL.LOGIN_STATE_DONE);
          that.$store.commit('setNeedLoadMusic', 1);
        } else {
          that.pwdMsg = res.data.errMsg;
        }
      });
    },
    getLoginState: function () {
      return this.$store.state.loginState;
    },
    loginPwdBack: function () {
      this.$store.commit('setLoginState', this.GLOBAL.LOGIN_STATE_PART0);
    }
  },
  created: function () {
    this.$store.commit('setLoginState', this.GLOBAL.LOGIN_STATE_PART0);
  },
  components: {
    LoginDialog
  }
}
</script>
<style scoped>
.login {
  width: 435px;
  height: 480px;
  margin-top: 87px;
  margin-bottom: 180px;
  display: inline-block;
}

.login p:first-child {
  font-size: 24px;
  font-style: oblique;
  font-weight: 700;
  margin-top: 70px;
}

.login .tag-tips {
  margin-top: 28px;
  font-size: 14px;
  color: #919191;
}

.login .back {
  margin-top: 80px;
}

.back {
  font-size: 18px;
  color: #f54f31;
  font-family: PingFangSC-Medium;
  letter-spacing: 0.5px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
}

.login-input {
  border-width: 0 0 1px 0;
  border-style: solid;
  border-color: #e3e3e3;
  display: block;
  margin: auto;
  text-align: center;
  width: 360px;
  height: 48px;
  vertical-align: middle;
  margin-top: 120px;
  font-size: 18px;
  outline: none;
  box-shadow: none;
}

.login-submit {
  display: block;
  margin: auto;
  text-align: center;
  width: 360px;
  height: 52.5px;
  color: #ffffff;
  background-color: #ff8700;
  background-size: 360px;
  border: 0px;
  border-radius: 6px;
  -moz-border-radius: 6px;
  -webkit-border-radius: 6px;
  margin-top: 60px;
  outline: none;
  box-shadow: none;
  cursor: pointer;
}

.login-submit:hover {
  opacity: 0.8;
}

.login-submit.login-submit-complete {
  opacity: 0.8;
}

.login-submit.login-submit-complete:hover {
  opacity: 0.8;
}

.login-submit {
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
}

.msg-tips {
  margin-top: 10px;
  font-size: 15px;
  color: #FF8700;
  letter-spacing: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue